import { atom } from "recoil";

/**
 * Global state to track dirty form
 * Do not use this recoil state directly, use "useDirtyForm" hooks instead
 */
export const DirtyFormState = atom<Array<string>>({
    key: 'state.DirtyForm',
    default: [],
});
